import { LoadingButton } from "@mui/lab";
import { Avatar, Box, Container, Paper, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import agent from "../../app/api/agent";

import ContactMailIcon from '@mui/icons-material/ContactMail';

export default function ContactPage() {
  const navigate = useNavigate()
  const {register, handleSubmit, setError, formState: {isSubmitting, errors, isValid}} = useForm({
      mode: 'onChange' // tell what mode we want it to use to valid inputs. onTouch: as soon as they click into an input and then click out again, it's going to validate the field
  })

  function handleApiErrors(errors: any) {
      if (errors) {
          errors.forEach((error: string) => {
              if (error.includes('Password')) {
                  setError('password', {message: error})
              } else if (error.includes('Email')) {
                  setError('email', {message: error})
              } else if (error.includes('Username')) {
                  setError('username', {message: error})
              }
          })
      }
  }

return (
  
    <Container component={Paper} maxWidth="sm" sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', p: 4}}>
      
        <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
          <ContactMailIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
            Contact Us
        </Typography>
        <Box component="form" 
          onSubmit={handleSubmit(data => 
            
             
              agent.Contact.contactUs(data) 
            
              .then(() => {
                  toast.success('We have received your message and will contact you as soon as we can')
                  navigate('/catalog')
              })
              .catch(error => handleApiErrors(error))
              )} 
              noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="Name"
            autoFocus
            {...register('name', {required: 'Your name is required'})} // register includes onChange and name
            error={!!errors.name} // !! casts username into a boolean. If it is false, it will give a red color
            helperText={errors?.name?.message as string}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            label="Email"
          
            {...register('email', {
                required: 'email is required',
                pattern: {
                    value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: 'Not a valid email address'
                }
                })} // register includes onChange and name
            error={!!errors.email} // !! casts username into a boolean. If it is false, it will give a red color
            helperText={errors?.email?.message as string}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            multiline
            label="Message"
            // type="text"
            {...register('message', {
                required:  'Message is required'
              })}
            error={!!errors.message} // !! casts username into a boolean. If it is false, it will give a red color
            helperText={errors?.message?.message as string}
          />
          
          <LoadingButton
            loading={isSubmitting}
            disabled={!isValid}
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Submit
          </LoadingButton>
          
        </Box>
      
      
    </Container>
  
)



}